import React, { Component } from "react";
import PropTypes from "prop-types";
import { Switch } from "antd";
import { connect } from "react-redux";
import {
	displayComLocation,
	makeIsComLocationChecked,
} from "../../../../../redux/selectors/survey/createSelector";
import {
	addEndLocationAction,
	removeEndLocationAction,
} from "../../../../../redux/actions/surveyActions";

function ComLocation(props) {
	//return null;
	if (!props.display) return null;

	const { location } = props;
	return (
		<div className="p-al-v-center">
			<span className="p-pdg-right-s">
				Commentaire à la fin de chaque emplacement {location.label}{" "}
			</span>
			<Switch
				checked={props.checked}
				onChange={checked => {
					if (checked) {
						props.addEndLocationAction();
					} else {
						props.removeEndLocationAction();
					}
				}}
			/>
		</div>
	);
}

ComLocation.propTypes = {
	location: PropTypes.object.isRequired,
};

const makeMapStateToProps = () => {
	const isComLocationChecked = makeIsComLocationChecked();

	const mapStateToProps = (state, props) => {
		return {
			checked: isComLocationChecked(state, props),
			display: displayComLocation(state),
		};
	};

	return mapStateToProps;
};

const mapDispatchToProps = (dispatch, props) => {
	return {
		addEndLocationAction: () => {
			dispatch(addEndLocationAction(props.location));
		},
		removeEndLocationAction: () => {
			dispatch(removeEndLocationAction(props.location));
		},
	};
};

export default connect(
	makeMapStateToProps,
	mapDispatchToProps
)(ComLocation);



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepActionsKpi/SurveyStepActionsKpiTabElements/ComLocation.js